export default __webpack_public_path__ + "static/factorydao-394e1d6e38316f103d91dfada012e69b.png";